/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  app.Filters.TreeItemFilterView = app.Filters.CheckboxView.extend({
    events: {
      'click': 'toggleCheck'
    },
    
    beforeRun: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#tree-item-filter-view');
    },
    
    run: function (data) {
      if (!_.isUndefined(data.model.get('index'))) {
        _.merge(data, { index: data.model.get('index') });
      }
      if (data.object && data.parent) {
        data.parent.append(this.template(data));
        this.setElement(data.parent.find('a:last'));
      }
      this.listenTo(Backbone, 'toggle-check-all-categories', this.toggleCheck);
    },
    
    toggleCheck: function () {
      $('#filter-category-item-all .selected').removeClass('selected');
      this.model.set('click', true);
    }
  });
})(jQuery);

}.call(window));